import { render, staticRenderFns } from "./EmployeePayslips.vue?vue&type=template&id=e241451a"
import script from "./EmployeePayslips.vue?vue&type=script&lang=js"
export * from "./EmployeePayslips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports